"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdlib_validation_1 = require("@groupby/stdlib-validation");
const content_type_1 = require("content-type");
class MediaType {
    constructor(serialized) {
        this.typeName = '';
        this.subtypeName = '';
        this._parameters = new Map();
        let parsed;
        try {
            parsed = content_type_1.parse(serialized);
        }
        catch (e) {
            throw new stdlib_validation_1.ValidationException(e.message);
        }
        this.fullName = parsed.type;
        for (const key of Object.keys(parsed.parameters)) {
            this._parameters.set(key.toLowerCase(), parsed.parameters[key]);
        }
    }
    static get APPLICATION_OCTET_STREAM() {
        return new MediaType('application/octet-stream');
    }
    get fullName() {
        return `${this.typeName}/${this.subtypeName}`;
    }
    set fullName(value) {
        const [typeName, subtypeName] = value.toLowerCase().split('/');
        this.typeName = typeName;
        this.subtypeName = subtypeName;
    }
    get parameters() {
        return this._parameters;
    }
    serialize() {
        const parameters = {};
        this._parameters.forEach((value, key) => (parameters[key] = value));
        return content_type_1.format({ type: this.fullName, parameters });
    }
}
exports.MediaType = MediaType;
//# sourceMappingURL=media-type.js.map